var _path, _path2, _g, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C33.3137 3.86554e-07 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 9.66416e-08 33.3137 0 30V6C3.86566e-07 2.68629 2.68629 9.66385e-08 6 0H30Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26.5H11V9.5H25V26.5Z",
    stroke: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5C17.4468 9.5 17 9.94687 17 10.5V11.0594C14.7343 11.4188 13 13.3812 13 15.75V16.7937C13 18.2125 12.5156 19.5906 11.6312 20.6969L11.1656 21.2812C10.9843 21.5063 10.95 21.8156 11.075 22.075C11.2 22.3344 11.4625 22.5 11.75 22.5H24.25C24.5375 22.5 24.8 22.3344 24.925 22.075C25.05 21.8156 25.0156 21.5063 24.8343 21.2812L24.3687 20.7C23.4843 19.5906 23 18.2125 23 16.7937V15.75C23 13.3812 21.2656 11.4188 19 11.0594V10.5C19 9.94687 18.5531 9.5 18 9.5ZM18 12.5H18.25C20.0437 12.5 21.5 13.9563 21.5 15.75V16.7937C21.5 18.2906 21.9343 19.75 22.7406 21H13.2593C14.0656 19.75 14.5 18.2906 14.5 16.7937V15.75C14.5 13.9563 15.9562 12.5 17.75 12.5H18ZM20 23.5H18H16C16 24.0312 16.2093 24.5406 16.5843 24.9156C16.9593 25.2906 17.4687 25.5 18 25.5C18.5312 25.5 19.0406 25.2906 19.4156 24.9156C19.7906 24.5406 20 24.0312 20 23.5Z",
    fill: "#6B7280"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.5C24.933 8.5 26.5 10.067 26.5 12C26.5 13.933 24.933 15.5 23 15.5C21.067 15.5 19.5 13.933 19.5 12C19.5 10.067 21.067 8.5 23 8.5Z",
    fill: "#EF4444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.5C24.933 8.5 26.5 10.067 26.5 12C26.5 13.933 24.933 15.5 23 15.5C21.067 15.5 19.5 13.933 19.5 12C19.5 10.067 21.067 8.5 23 8.5Z",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_8179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5H25V25.5H11V9.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationBell);
export default __webpack_public_path__ + "static/media/ic_notification_bell.a0965adbf4d4e8e7142c8376602392a1.svg";
export { ForwardRef as ReactComponent };